<div class="bg">
  <div class="box">
    <p-card>
        <div class="text-4xl">Необходима оплата</div>
        
        <hr class="my-6">
        <p>Похоже вы не оплатили услуги сервиса. <br/>
        Пожалуйста обратитесь к постащику.</p>
        
        </p-card>
    </div>
</div>